// src/components/Signup.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { supabase } from '../supabase';

function Signup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    

    if (password !== confirmPassword) {
        setError('Passwords do not match.');
        return;
    }

    // Step 1: Sign up user
    const { data, error } = await supabase.auth.signUp({
        email,
        password
    });

    if (error) {
        setError(error.message);
    } else {
        const user = data.user;

        if (user) {
            // Step 2: Store user details in the database
            const { error: insertError } = await supabase
                .from('users')
                .insert([{ id: user.id, email: user.email, role: 'clientB' }]);

            if (insertError) {
                console.error('Error storing user in DB:', insertError.message);
            }
        }

        alert('Signup successful. Check your email for verification!');
        navigate('/'); // Redirect to login page
    }
  };

    const handleGoogleSignup = async () => {
          const { data, error } = await supabase.auth.signInWithOAuth({
              provider: 'google'
          });
  
          if (error) {
              console.error("Error signing in with Google: ", error);
              setError("Error signing in with Google. Please try again.");
          }
      };


  return (
    <div className="auth-form">
      <h1>Sign Up</h1>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSignup}>
        <label>Email:</label>
        <input 
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        
        <label>Password:</label>
        <input 
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <label>Confirm Password:</label>
        <input
          type="password"
          placeholder="Confirm your password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        
        <button type="submit" style={{ marginBottom: '8px' }}>Sign Up</button>    
       </form>
        
        {/* <button 
  onClick={handleGoogleSignup} 
  style={{ color: 'white', backgroundColor: 'black', border: '1px solid black', padding: '10px', cursor: 'pointer' }}
>
  Continue with Google
</button>           */}
  <p>Already have an account? <a href="/login">Log in</a></p>
  </div>
  );
}

export default Signup;
